export interface ISiteSectionTheme {
	backgroundColor: string;
	color: string;
}

export const theme: ISiteSectionTheme = {
	backgroundColor: '',
	color: '',
};
